$(document).ready(function () {
    var interval = setInterval(function () {
        if (document.readyState === 'complete') {
            window.customOptionHideLineItem = customOptionHideLineItem;
            window.customOptionHideLineItem.initOptionHideLineItem();
            clearInterval(interval);
        }
    }, 100);
    var customOptionHideLineItem = {
        initOptionHideLineItem: function optionHideLineItem() {
            $('body').find('[data-hulkapps-line-properties] .product-option').each(function () {
                var optionName = $(this).find('dt').text();
                if (optionName.includes('Recipient Name:')) {
                    // console.log("optionName -->", $(this));
                    $(this).css('display', 'none');
                }
                if (optionName.includes('Sender Name:')) {
                    // console.log("optionName -->", $(this));
                    $(this).css('display', 'none');
                }
                if (optionName.includes('Type note here (250 character limit):')) {
                    // console.log("optionName -->", $(this));
                    $(this).css('display', 'none');
                }
                if (optionName.includes('sizeVariantselection:')) {
                    // console.log("optionName -->", $(this));
                    $(this).css('display', 'none');
                }
                if (optionName.includes('Special Occasion Sleeve:')) {
                    //console.log("optionName -->", $(this));
                    var productTitle = $(this).closest('[data-hulkapps-line-properties]').siblings('.ajax-cart__product-title').find('.product-title').text();
                    // console.log("productTitle -->", $.trim(productTitle));
                    var optionValues = $(this).find('dd').text();
                    if ($.trim(productTitle).includes('48')) {
                        if (!optionValues.includes(' [')) {
                            $(this).find('dd').append(' [ $6.00 ]');
                        }
                    }
                    if ($.trim(productTitle).includes('24')) {
                        if (!optionValues.includes(' [')) {
                            $(this).find('dd').append(' [ $4.00 ]');
                        }
                    }
                    if ($.trim(productTitle).includes('12')) {
                        if (!optionValues.includes(' [')) {
                            $(this).find('dd').append(' [ $2.00 ]');
                        }
                    }
                    window.appendedValueTrue = false;
                }
            });
        }
    }
    $('body').on('click', '.edit_cart_option', function () {
        var setRefresh = setInterval(function () {
            if ($(".hulkapp_popup-heading").length > 0) {
                setTimeout(function () {
                    var popupHeading = $('.hulkapp_popup-heading').text().split('(')[0];
                    var popupHeadingSize = popupHeading.split('-')[1];
                    // console.log("popupHeadingSize -->", popupHeadingSize);
                    $('body').find('.hulkapp_popupBox .hulkapps_option.sizeVariantselection').each(function () {
                        // var defaultOptionName = $(this).find('.hulkapps_option_name').attr('aria-label');
                        var fetchClass = $(this).find('.hulkapps_option_value .hulkapps_option_child');
                        fetchClass.find('option').each(function (index, e) {
                            var r = $(this).data('conditional-value');
                            if (r == $.trim(popupHeadingSize)) {
                                // $(this).attr('selected', 'selected');
                                var selectedPriceValue = $(this).val();
                                //console.log("selectedPriceValue -->", selectedPriceValue);
                                $(this).prop('selected', true).change();
                                $('.sizeVariantselection').find('.hulkapps_option_value [type="hidden"]').val(selectedPriceValue);
                            }

                        });
                    });
                }, 1800);
                clearInterval(setRefresh);

            }
        }, 10);
    });
    document.getElementsByClassName('product-form__input').forEach(function (element) {
        element.value = '1';
    });
});